import React from 'react';
import { Outlet } from 'react-router-dom';
import {
  AmbientCommandIntelligenceRouteSync,
  useAmbientCommandIntelligenceContext,
} from '../../command-intelligence/ambient-context';
import { useInitializeMenu } from '../../../util/useMenu';

export const Authenticated = ({ menuConfig }) => {
  useInitializeMenu(menuConfig);
  const ambient = useAmbientCommandIntelligenceContext();

  return (
    <>
      {ambient?.enabled ? <AmbientCommandIntelligenceRouteSync /> : null}
      <Outlet />
    </>
  );
};
